/**
 * Builds Hasura-style `where` for erpLaborTickets scoped to the current OperatorView machine.
 *
 * @param {Object} params
 * @param {number} params.machineRef - Required; callers should skip the query when missing.
 * @param {boolean} params.isMesEnabled - company + machine MES (see getIsMESEnabled)
 * @param {boolean} params.isMesErpDispatchEnabled - MES + erp job dispatch (see getIsMESErpJobDispatchEnabled)
 * @param {string|null|undefined} params.laborResourceId - from machine settings
 * @returns {Object} erpLaborTickets_bool_exp fragment
 */
export function getLaborTicketWhereForMachine({
  machineRef,
  isMesEnabled,
  isMesErpDispatchEnabled,
  laborResourceId,
}) {
  if (!isMesEnabled) {
    return { resource: { machineRef: { _eq: machineRef } } };
  }

  if (
    isMesErpDispatchEnabled &&
    laborResourceId != null &&
    laborResourceId !== ''
  ) {
    return { resourceId: { _eq: laborResourceId } };
  }

  return { machineRef: { _eq: machineRef } };
}
